import { FfNgxLoadingScreenConfig } from '@fagforbundet/ngx-components';

export const loadingScreenConfig: FfNgxLoadingScreenConfig = {
  debug: false,
  showLoadingScreenOnNavigation: true,
};
